<template>
  <div class="app">
    <div style="padding-right:8px;display:flex;position: fixed;z-index: 99;background-color:white;flex-direction: column;"
      v-if="isMobile">
      <div style="display:flex;">
        <div style="display:flex;align-items: center;justify-content: center;">
          <img src="./img/zhanshi.png" alt="logo" class="logo" />
        </div>
        <Header :activeIndex="4" />
      </div>
      <div class="hengtiao">
        <div class="xiangji"><i class="el-icon-camera"></i></div>
        <div class="gerenxinxi">职业方向规划</div>
      </div>
    </div>
    <div class="hengtiao1" v-if="!isMobile">
    </div>
    <div class="hengtiao" v-if="!isMobile">
      <div class="xiangji"><i class="el-icon-camera"></i></div>
      <div class="gerenxinxi">职业方向规划</div>
    </div>
    <div class="head01">
      <Header :activeIndex="4" v-if="!isMobile" />
      <div class="back">
        <img :src="tisheng" alt="提升热线 ： 010-8942 2330" class="tupian">
        <div class="rexian">提升热线： 010-8492 2330</div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from './Header.vue';
import Footer from './Footer.vue'
export default {
  name: 'zhiyefangxiang',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      tisheng: require('@/components/img/tisheng.jpg'),
      isMobile: false
    }
  },
  mounted() {
    this.checkMobile()
    window.addEventListener('resize', this.checkMobile)
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
  }
}
</script>
<style scoped>
.hengtiao1 {
  height: 8px;
  width: 100%;
  background-color: white;
  display: flex;
  align-items: center;
}

.hengtiao {
  height: 50px;
  width: 100%;
  background-color: #3572e5;
  color: white;
  display: flex;
  align-items: center;
}

.xiangji {
  margin-left: 20px;
  font-weight: 800;
  font-size: 28px;
}

.xiangji2 {
  font-weight: 900;
  font-size: 155px;
  border: 1px soild #DCDFE6;
}

.gerenxinxi {
  margin-left: 20px;
  font-weight: 700;
}

.head01 {
  display: flex;
  gap: 90px;
}

.back {
  background-color: #2b2d39;
  height: 92vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.rexian {
  font-size: 42px;
  color: white;
}

@media (max-width: 768px) {

  .head01 {
    gap: 0px;
    align-items: center;
    padding-top: 140px;
  }

  .back {
    height: auto;
    padding: 20px;
    margin-top: 10px;
  }

  .rexian {
    font-size: 19px;
  }

  .tupian {
    width: 100%;
  }

  .logo {
    width: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/zhiyefangxiang.vue